export default __webpack_public_path__ + "static/media/camera.028e9d1a.svg";